import React, { useState } from "react";
import ReactPaginate from "react-paginate";
import Card from "../Card/Card";
import ButtonRound from "../Labels/ButtonRound";
import { PaginationProps } from "../../types/components";
import { Product } from '../../api-client/';
import { useNavigate } from "react-router-dom";

function Pagination({ category, products, limit, itemsPerPage }: PaginationProps) {
  const [itemOffset, setItemOffset] = useState(0);
  const navigate = useNavigate();
  const pageSize = itemsPerPage || 5;

  // Asegurarse de que products es un array antes de filtrar
  const safeProducts = Array.isArray(products) ? products : [];

  // Filtramos los productos según la Category seleccionada
  const filteredProducts = category === ""
    ? safeProducts
    : safeProducts.filter((product: Product) => product.category?.name === category);

  // Calculamos los productos actuales a mostrar en la página
  const endOffset = itemOffset + pageSize;
  const currentItems = filteredProducts.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filteredProducts.length / pageSize);

  // Manejador del cambio de página
  const handlePageClick = (event: { selected: number }) => {
    const newOffset = (event.selected * pageSize) % filteredProducts.length;
    setItemOffset(newOffset);
  };

  return (
    <div className="flex w-full justify-center py-8">
      <div className="w-full max-w-[100rem]">
        {/* Grid de productos */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 mb-8">
          {currentItems.map((product: Product, index: number) => (
            <Card
              id={product.id!}
              key={index}
              name={product.name}
              imageUrl={product.image!}
              imageUrls={product.images ?? []}
              price={product.price}
              phrases={product.phrases}
              description={product.description}
              
            />
          ))}
        </div>
        {/* Paginación */}
          {filteredProducts.length > pageSize && typeof limit === 'undefined' && (
          <div className="flex justify-center">
            <ReactPaginate
              breakLabel="..."
              nextLabel={<ButtonRound text="siguiente >" onClick={() => {}} isSelected={false} />}
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              previousLabel={<ButtonRound text="< anterior" onClick={() => {}} isSelected={false} />}
              renderOnZeroPageCount={null}
              containerClassName="flex items-center"
              pageClassName="px-3 py-1"
              activeClassName="bg-blue-500 text-white"
              previousClassName="px-3 py-1"
              nextClassName="px-3 py-1"
              disabledClassName="opacity-50 cursor-not-allowed"
            />
          </div>
        )}
        { typeof limit !== 'undefined' &&  <div className="w-full flex justify-center">
          <ButtonRound 
                text={"View All"}
                onClick={() => navigate('/products')}
                isSelected={true}
              />
        </div> }
      </div>
    </div>
  );
}

export default Pagination;